// Provider payloads and credentials are deliberately not sent to the console.
export const logger={warn:(_scope:string,_message?:string,_error?:unknown)=>{},error:(_scope:string,_message?:unknown,_error?:unknown)=>{},info:(_scope:string,_message?:unknown)=>{}};
